import { Alignment, Fit, Layout, useRive } from '@rive-app/react-webgl2';
import { UserContext } from 'contexts/user';
import { useContext, useState } from 'react';
import { CommunityShotItem } from 'types/community';
import RemixModal from '../remix/RemixModal';
import * as analytics from 'lib/analytics';
import styles from './EmptyRemixes.module.css';
import { navigateTo } from 'lib/utils';

type Props = {
  shotItem: CommunityShotItem;
};

export default function EmptyRemixes({ shotItem }: Props) {
  const { user } = useContext(UserContext);

  const [isRemixModalOpen, setIsRemixModalOpen] = useState<boolean>(false);

  const { RiveComponent } = useRive({
    src: '/static/riv/robot_cleaner_cropped.riv',
    animations: ['Test', 'dust_fly'],
    autoplay: true,
    layout: new Layout({
      fit: Fit.Contain,
      alignment: Alignment.TopCenter,
    }),
  });

  function onRemixClick() {
    if (user?.signedIn) {
      return setIsRemixModalOpen(true);
    }

    const loginUrl = `/login?redirect=${encodeURIComponent(
      window.location.pathname
    )}`;
    // If not signed in, redirect to the login page
    navigateTo(loginUrl);
    analytics.clickCommunityRemix(
      shotItem.communityPostId,
      shotItem.fileId,
      shotItem.title,
      shotItem.isRemix,
      'redirect_to_login'
    );
  }

  return (
    <div className={styles.Container}>
      <RemixModal
        display={isRemixModalOpen}
        onClose={() => setIsRemixModalOpen(false)}
        shotItem={shotItem}
      />
      <div className={styles.Banner}>No remixes yet. Be the first!</div>
      <button className={styles.Button} onClick={onRemixClick}>
        Remix
      </button>
      <div className={styles.Robot}>
        <RiveComponent />
      </div>
    </div>
  );
}
